import { Flex } from "@chakra-ui/react";
import React from "react";
import FamilyMembers from "./components/FamilyMembers";

function Data() {

  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <FamilyMembers
      />
    </Flex>
  );
}

export default Data;
